export default __webpack_public_path__ + "static/media/jay_bhavani.b2d5a038.jpeg";